export interface Transaltor {

  translate: string;
  label: string;

}

const listTransaltor: Transaltor[][] = [];
export default listTransaltor;
